import { PrimaryButton, TextField } from "@fluentui/react";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { localize } from "src/l10n";
import { FormControl, FormSection } from "src/ui/components/Forms";
import "./TimelineLabelForm.scss";
import SpintrLoader from "src/ui/components/Loader";
import { savePlannerLabelAsync } from "src/api/plannerApi";
import { queryPlannerLabels } from "src/redux";
import { useDispatch, useSelector } from "react-redux";

interface IProps {
    date: Date;
    onDone: () => void;
}

interface IStateProps {
    labelLookup: { [id: string]: Spintr.PlannerLabel };
}

interface IState {
    momentDate: moment.Moment;
    text: string;
    isLoading: boolean;
}

const TimelineLabelForm = (props: IProps) => {
    const dispatch = useDispatch();

    const stateProps = useSelector<Spintr.AppState, IStateProps>(
        (appState) => ({
            labelLookup: appState.planner.labelsById,
        }),
        (left, right) => {
            if (left.labelLookup !== right.labelLookup) {
                return false;
            }

            return true;
        }
    );

    const [state, setState] = useState<IState>({
        momentDate: moment(props.date),
        text: "",
        isLoading: false
    })

    const save = useCallback((ev) => {
        if (ev) {
            ev.preventDefault();
        }

        setState((s) => ({
            ...s,
            isLoading: true
        }));

        savePlannerLabelAsync({ id: null, date: state.momentDate.format("YYYY-MM-DD"), text: state.text }).then(() => {
            setState((s) => ({
                ...s,
                isLoading: false
            }));

            dispatch(queryPlannerLabels());

            props.onDone();
        }).catch(() => {
            setState((s) => ({
                ...s,
                isLoading: false
            }));
        })
    }, [state.text, state.isLoading, props.date, dispatch, props.onDone, state.momentDate]);

    useEffect(() => {
        for (const label of Object.values(stateProps.labelLookup)) {
            if (label.formattedDate.getFullYear() === props.date.getFullYear() &&
                label.formattedDate.getMonth() === props.date.getMonth() &&
                label.formattedDate.getDate() === props.date.getDate()) {
                setState((s) => ({
                    ...s,
                    text: label.text
                }));
            }
        }
    }, [props.date, stateProps.labelLookup]);

    return (
        <div className="TimelineLabelForm">
            <span>{localize("ADD_LABEL_TO") + " " + state.momentDate.format("dddd, LL")}</span>
            {!state.isLoading && (
                <form onSubmit={save}>
                    <FormSection>
                        <FormControl>
                            <TextField
                                value={state.text}
                                className="textField"
                                placeholder={localize("SkrivNagot") + "..."}
                                resizable={false}
                                onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newValue?: string) => {
                                    setState((s) => ({
                                        ...s,
                                        text: newValue
                                    }));
                                }}
                            />
                        </FormControl>
                        <PrimaryButton
                            text={localize("Spara")}
                            onClick={save}
                        />
                    </FormSection>
                </form>
            )}
            {state.isLoading && <SpintrLoader />}
        </div>
    )
}

export default TimelineLabelForm;
